@if (templates$ | async; as templates) {
  <div>
    @if (searchResultText) {
      <nova-banner bannerType="search" [bannerMessage]="searchResultText"></nova-banner>
    }
    <mat-radio-group [formControl]="templateSelect">
      <table mat-table [dataSource]="templates" class="nova__table template-list" aria-describedby="template list">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef scope="col"> </th>
          <td mat-cell *matCellDef="let element">
            @if (isTemplateCompatible(element)) {
              <span>
                <mat-radio-button [value]="element"></mat-radio-button>
              </span>
            } @else {
              <span class="material-icons template-error"
              matTooltip="The template has multiple documents and is not compatible with Nova integration">error</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef scope="col">Template Title</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>
          <ng-container matColumnDef="pageCount">
          <th mat-header-cell *matHeaderCellDef scope="col">Page</th>
          <td mat-cell *matCellDef="let element">{{ element.pageCount }}</td>
        </ng-container>
        <ng-container matColumnDef="preview">
          <th mat-header-cell *matHeaderCellDef scope="col"> Actions </th>
          <td mat-cell *matCellDef="let element">
            <a class="nova__link" (click)="getTemplateImage(element.id, element.name)">Preview</a>
          </td>
        </ng-container>
        <tr mat-header-row class="header-row" *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
        [ngClass]="{'incompatible': !isTemplateCompatible(row)}"></tr>
      </table>
    </mat-radio-group>
  </div>
}